// Copyright (c) 2020 WiseTime. All rights reserved.

import { createAction } from "@reduxjs/toolkit"
import { SiteId } from "features/user-context/slice"
import {
  SearchTagsRequest,
  UpdateTagRequest,
  CreateFavouriteTagRequest,
  DeleteFavouriteTagRequest,
  ReorderFavouriteTagRequest,
  CreateTagKeywordRequest,
  DeleteTagKeywordRequest,
  GetTagRequest,
  GetTagCategoryRequest,
} from "generated/legebill/site/tag/v4/tag_pb"
import { IdsList } from "./tags"

export type FetchFavouriteTagsPayload = {
  siteId: SiteId,
  swallowFailure?: boolean,
}

export type FetchRecentTagsPayload = {
  swallowFailure: boolean,
}

export type DeleteFavouriteTagPayload = {
  request: DeleteFavouriteTagRequest,
  siteId: SiteId,
}

export type ReorderFavouriteTagPayload = {
  request: ReorderFavouriteTagRequest,
  siteId: SiteId,
}

export type GetTagPayload = {
  request: GetTagRequest,
  swallowFailure?: boolean,
}

export type ListTagsByCategoryPayload = {
  tagCategoryId: string,
  swallowFailure?: boolean,
}

export const getTag = createAction<GetTagPayload>("tags/get-tag")
export const getTagCategory = createAction<GetTagCategoryRequest>("tags/get-tag-category")
// fetches recent tags for the active day of current site
export const fetchRecentTags = createAction<FetchRecentTagsPayload | undefined>("tags/fetch-recent-tags")
export const updateTag = createAction<UpdateTagRequest>("tags/update-tag")
export const fetchFavouriteTags = createAction<FetchFavouriteTagsPayload>("tags/fetch-favourite-tags")
export const searchTags = createAction<SearchTagsRequest>("tags/search-tags")
export const searchTagsShallow = createAction<SearchTagsRequest>("tags/search-tags-shallow")
export const createFavouriteTag = createAction<CreateFavouriteTagRequest>("tags/create-favourite-tag")
export const deleteFavouriteTag = createAction<DeleteFavouriteTagPayload>("tags/delete-favourite-tag")
export const reorderFavouriteTag = createAction<ReorderFavouriteTagPayload>("tags/reorder-favourite-tag")

export const createTagKeyword = createAction<CreateTagKeywordRequest>("tags/create-tag-keyword")
export const deleteTagKeyword = createAction<DeleteTagKeywordRequest>("tags/delete-tag-keyword")

export const listTagsByCategory = createAction<ListTagsByCategoryPayload>("tags/list-tags-by-category")
export const batchGetTagCategories = createAction<IdsList>("tags/batch-get-tag-categories")

export const orderByPersisted = createAction("tags/order-by-persisted")
export const orderByPersistFailed = createAction("tags/order-by-persist-failed")
export const recentOrderByPersisted = createAction("tags/recent-order-by-persisted")
export const recentOrderByPersistFailed = createAction("tags/recent-order-by-persist-failed")
export const viewModePersisted = createAction("tags/view-mode-persisted")
export const viewModePersistFailed = createAction("tags/view-mode-persist-failed")
export const loadOrderByFromStorage = createAction("tags/load-order-by-from-storage")
export const loadOrderByFromStorageFailed = createAction("tags/load-order-by-from-storage-failed")
export const loadRecentOrderByFromStorage = createAction("tags/load-recent-order-by-from-storage")
export const loadRecentOrderByFromStorageFailed = createAction("tags/load-recent-order-by-from-storage-failed")
export const loadViewModeFromStorage = createAction("tags/load-view-mode-from-storage")
export const loadViewModeFromStorageFailed = createAction("tags/load-view-mode-from-storage-failed")
